import { BellRing, Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { errText, papi } from "../portalApi";
import { fdate } from "./crmUtil";

const run = async (fn, ok, onChanged) => { try { await fn(); if (ok) toast.success(ok); onChanged(); } catch (e) { toast.error(errText(e)); } };

export const Followups = ({ c, today, readOnly, onChanged }) => (
  <div className="space-y-2">
    {c.followups.map((f) => (
      <div key={f.id} className={`flex items-start gap-2 rounded-lg p-2 text-sm ${f.date <= today ? "bg-amber-50" : "bg-slate-50"}`} data-testid={`crm-followup-${f.id}`}>
        <BellRing className={`mt-0.5 h-4 w-4 shrink-0 ${f.date <= today ? "animate-pulse text-amber-500" : "text-slate-400"}`} />
        <span className="flex-1"><b>{f.date === today ? "Today" : fdate(f.date)}</b>{f.date < today && <span className="ml-1 text-xs font-semibold text-rose-600">overdue</span>} — {f.note}</span>
        {!readOnly && <button onClick={() => run(() => papi("post", `/crm/followups/${f.id}/done`), "Marked done", onChanged)} className="inline-flex items-center gap-1 rounded-md border bg-white px-2 py-0.5 text-xs hover:bg-emerald-50" data-testid={`crm-followup-done-${f.id}`}><Check className="h-3 w-3" /> Done</button>}
      </div>))}
    {!c.followups.length && <p className="text-sm text-slate-400">No reminder set. It rings in your Hub bell on the day.</p>}
  </div>
);

export const Notes = ({ c, readOnly, onChanged }) => (
  <div>
    {!readOnly && <input placeholder="Add a note and press Enter…" className="mb-2 w-full rounded-lg border px-3 py-2 text-sm" data-testid="crm-add-note-input"
      onKeyDown={(e) => {
        const t = e.target;
        if (e.key === "Enter" && t.value.trim()) run(() => papi("post", "/crm/notes", { key: c.key, text: t.value }).then(() => { t.value = ""; }), "Note saved", onChanged);
      }} />}
    {c.notes.map((n) => (
      <p key={n.id} className="group flex items-start gap-2 border-t py-1.5 text-sm" data-testid={`crm-note-${n.id}`}>
        <span className="w-16 shrink-0 text-xs text-slate-400">{fdate(n.at)}</span><span className="flex-1 whitespace-pre-wrap">{n.text}</span>
        {!readOnly && <button onClick={() => window.confirm("Delete this note?") && run(() => papi("delete", `/crm/notes/${n.id}`), "", onChanged)} className="text-slate-300 hover:text-rose-600" data-testid={`crm-note-del-${n.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}
      </p>))}
    {!c.notes.length && <p className="text-sm text-slate-400">No notes yet.</p>}
  </div>
);
